import { reviewCellSelector } from '../../utilities/reviewCellSelector';
import useGridCitationSelectionStore from '../../utilities/useGridCitationSelectionStore';

// Same ring technique as the review outline, in the selection colour.
const RING =
  'content: ""; position: absolute; inset: 0; pointer-events: none; z-index: 2; box-shadow: inset 0 0 0 2px var(--blue-500, #1f55f8);';

/**
 * Outlines every cell in the citation selection. The rule is derived from the store and
 * addresses cells by the grid's own data attributes, so it follows every add, remove and
 * exit, and a grid re-render that rewrites a cell's class cannot drop it.
 */
const GridCitationSelectionOutline = () => {
  const selected = useGridCitationSelectionStore(s => s.selected);
  if (selected.length === 0) {
    return null;
  }
  const targets = selected
    .map(item => `${reviewCellSelector({ securityId: Number(item.columnId), fieldAlias: item.alias })}::after`)
    .join(', ');
  return <style data-testid="grid-citation-selection-outline">{`${targets} { ${RING} }`}</style>;
};

export default GridCitationSelectionOutline;
